import React from "react";
import OrderDTO from "@/dto/order/OrderDTO";
import OrderTag from "@/enum/OrderTag";
import ShopDTO from "@/dto/shop/ShopDTO";
import OrderTagWrap from "../OrderTagWrap";
import { Tooltip } from "antd";

/**
 * 阿里平台标签组件
 * 包含所有阿里相关的标签逻辑
 */
export default function useAliTagIcons(order: OrderDTO, orderTagSet: Set<OrderTag>, shop: ShopDTO) {
    const icons = [];

    if (orderTagSet.has(OrderTag.ALI_SEND_ABOUT_TO_OVERDUE)) {
        icons.push(
            <Tooltip title="发货即将超时" key={OrderTag.ALI_SEND_ABOUT_TO_OVERDUE}>
                <OrderTagWrap className="order-icon icon-important" orderTag={OrderTag.ALI_SEND_ABOUT_TO_OVERDUE}>
                    即将超时
                </OrderTagWrap>
            </Tooltip>,
        );
    }

    if (orderTagSet.has(OrderTag.ALI_SEND_OVERDUE)) {
        icons.push(
            <Tooltip title="发货已超时" key={OrderTag.ALI_SEND_OVERDUE}>
                <OrderTagWrap className="order-icon icon-important" orderTag={OrderTag.ALI_SEND_OVERDUE}>
                    已超时
                </OrderTagWrap>
            </Tooltip>,
        );
    }

    if (orderTagSet.has(OrderTag.ALI_DELIVER_OVERDUE)) {
        icons.push(
            <Tooltip title="揽收已超时" key={OrderTag.ALI_DELIVER_OVERDUE}>
                <OrderTagWrap className="order-icon icon-important" orderTag={OrderTag.ALI_DELIVER_OVERDUE}>
                    已超时
                </OrderTagWrap>
            </Tooltip>,
        );
    }

    if (orderTagSet.has(OrderTag.ALI_C2M_RESHIPMENT)) {
        icons.push(
            <OrderTagWrap
                className="order-icon icon-unimportant"
                key={OrderTag.ALI_C2M_RESHIPMENT}
                orderTag={OrderTag.ALI_C2M_RESHIPMENT}
            />,
        );
    }

    if (orderTagSet.has(OrderTag.ALI_OUT_ORDER_TAOBAO)) {
        icons.push(
            <Tooltip
                key={OrderTag.ALI_OUT_ORDER_TAOBAO}
                title="淘系加密分销：下游订单为淘系平台订单，请使用菜鸟电子面单打印"
            >
                <OrderTagWrap
                    className="order-icon icon-important"
                    style={{ whiteSpace: "nowrap" }}
                    orderTag={OrderTag.ALI_OUT_ORDER_TAOBAO}
                />
            </Tooltip>,
        );
    }

    if (orderTagSet.has(OrderTag.ALI_OUT_ORDER_PDD)) {
        icons.push(
            <Tooltip
                title="拼多多加密分销：下游订单为拼多多平台订单，请使用拼多多电子面单打印"
                key={OrderTag.ALI_OUT_ORDER_PDD}
            >
                <OrderTagWrap
                    className="order-icon icon-important"
                    style={{ whiteSpace: "nowrap" }}
                    orderTag={OrderTag.ALI_OUT_ORDER_PDD}
                />
            </Tooltip>,
        );
    }

    if (orderTagSet.has(OrderTag.ALI_OUT_ORDER_DY)) {
        icons.push(
            <Tooltip
                title="抖音加密分销：下游订单为抖店平台订单，请使用抖音电子面单打印"
                key={OrderTag.ALI_OUT_ORDER_DY}
            >
                <OrderTagWrap
                    className="order-icon icon-important"
                    style={{ whiteSpace: "nowrap" }}
                    orderTag={OrderTag.ALI_OUT_ORDER_DY}
                />
            </Tooltip>,
        );
    }

    if (orderTagSet.has(OrderTag.ALI_OUT_ORDER_KWAI)) {
        icons.push(
            <Tooltip
                title="快手加密分销：下游订单为快手平台订单，请使用快手电子面单打印"
                key={OrderTag.ALI_OUT_ORDER_KWAI}
            >
                <OrderTagWrap
                    className="order-icon icon-important"
                    style={{ whiteSpace: "nowrap" }}
                    orderTag={OrderTag.ALI_OUT_ORDER_KWAI}
                />
            </Tooltip>,
        );
    }

    if (orderTagSet.has(OrderTag.ALI_OUT_ORDER_XHS)) {
        icons.push(
            <Tooltip
                key={OrderTag.ALI_OUT_ORDER_XHS}
                title="小红书加密分销：下游订单为小红书平台订单，请使用小红书电子面单打印"
            >
                <OrderTagWrap
                    className="order-icon icon-important"
                    style={{ whiteSpace: "nowrap" }}
                    orderTag={OrderTag.ALI_OUT_ORDER_XHS}
                />
            </Tooltip>,
        );
    }

    if (orderTagSet.has(OrderTag.ALI_OUT_ORDER_JD)) {
        icons.push(
            <Tooltip
                key={OrderTag.ALI_OUT_ORDER_JD}
                title="京东加密分销：下游订单为京东平台订单，请使用京东平台电子面单打印"
            >
                <OrderTagWrap
                    className="order-icon icon-important"
                    style={{ whiteSpace: "nowrap" }}
                    orderTag={OrderTag.ALI_OUT_ORDER_JD}
                />
            </Tooltip>,
        );
    }

    if (orderTagSet.has(OrderTag.ALI_OUT_ORDER_WEIXIN)) {
        icons.push(
            <Tooltip
                key={OrderTag.ALI_OUT_ORDER_WEIXIN}
                title="微信小店加密分销：下游订单为微信小店平台订单，请使用微信小店平台电子面单打印"
            >
                <OrderTagWrap
                    className="order-icon icon-important"
                    style={{ whiteSpace: "nowrap" }}
                    orderTag={OrderTag.ALI_OUT_ORDER_WEIXIN}
                />
            </Tooltip>,
        );
    }

    if (orderTagSet.has(OrderTag.ALI_PLAINTEXT_OUT_ORDER_TAOBAO)) {
        icons.push(
            <OrderTagWrap
                key={OrderTag.ALI_PLAINTEXT_OUT_ORDER_TAOBAO}
                className="order-icon icon-important"
                style={{ whiteSpace: "nowrap" }}
                orderTag={OrderTag.ALI_PLAINTEXT_OUT_ORDER_TAOBAO}
            />,
        );
    }

    if (orderTagSet.has(OrderTag.ALI_PLAINTEXT_OUT_ORDER_PDD)) {
        icons.push(
            <OrderTagWrap
                key={OrderTag.ALI_PLAINTEXT_OUT_ORDER_PDD}
                className="order-icon icon-important"
                style={{ whiteSpace: "nowrap" }}
                orderTag={OrderTag.ALI_PLAINTEXT_OUT_ORDER_PDD}
            />,
        );
    }

    if (orderTagSet.has(OrderTag.ALI_PLAINTEXT_OUT_ORDER_DY)) {
        icons.push(
            <OrderTagWrap
                key={OrderTag.ALI_PLAINTEXT_OUT_ORDER_DY}
                className="order-icon icon-important"
                style={{ whiteSpace: "nowrap" }}
                orderTag={OrderTag.ALI_PLAINTEXT_OUT_ORDER_DY}
            />,
        );
    }

    if (orderTagSet.has(OrderTag.ALI_PLAINTEXT_OUT_ORDER_KWAI)) {
        icons.push(
            <OrderTagWrap
                key={OrderTag.ALI_PLAINTEXT_OUT_ORDER_KWAI}
                className="order-icon icon-important"
                style={{ whiteSpace: "nowrap" }}
                orderTag={OrderTag.ALI_PLAINTEXT_OUT_ORDER_KWAI}
            />,
        );
    }

    if (orderTagSet.has(OrderTag.ALI_PLAINTEXT_OUT_ORDER_XHS)) {
        icons.push(
            <OrderTagWrap
                key={OrderTag.ALI_PLAINTEXT_OUT_ORDER_XHS}
                className="order-icon icon-important"
                style={{ whiteSpace: "nowrap" }}
                orderTag={OrderTag.ALI_PLAINTEXT_OUT_ORDER_XHS}
            />,
        );
    }

    if (orderTagSet.has(OrderTag.ALI_PLAINTEXT_OUT_ORDER_JD)) {
        icons.push(
            <OrderTagWrap
                key={OrderTag.ALI_PLAINTEXT_OUT_ORDER_JD}
                className="order-icon icon-important"
                style={{ whiteSpace: "nowrap" }}
                orderTag={OrderTag.ALI_PLAINTEXT_OUT_ORDER_JD}
            />,
        );
    }

    if (orderTagSet.has(OrderTag.ALI_CAN_NOT_SHIP)) {
        icons.push(
            <Tooltip
                key={OrderTag.ALI_CAN_NOT_SHIP}
                title={
                    <div>
                        该订单包含暂不可发货商品项，如需操作打印发货请查看收货人地址下方的不可发货原因确认无误后再操作
                    </div>
                }
            >
                <OrderTagWrap className="order-icon icon-important" orderTag={OrderTag.ALI_CAN_NOT_SHIP} />
            </Tooltip>,
        );
    }

    if (orderTagSet.has(OrderTag.ALI_CUSTOMIZATION)) {
        icons.push(
            <Tooltip
                key={OrderTag.ALI_CUSTOMIZATION}
                title={<div>该订单为定制服务订单，请确保先完成定制后再打印发货！</div>}
            >
                <OrderTagWrap className="order-icon icon-important" orderTag={OrderTag.ALI_CUSTOMIZATION} />
            </Tooltip>,
        );
    }

    if (orderTagSet.has(OrderTag.ALI_CROSS_BORDER)) {
        icons.push(
            <OrderTagWrap
                className="order-icon icon-unimportant"
                key={OrderTag.ALI_CROSS_BORDER}
                orderTag={OrderTag.ALI_CROSS_BORDER}
            />,
        );
    }

    if (orderTagSet.has(OrderTag.ALI_MANAGED_SHIPPING)) {
        icons.push(
            <Tooltip key={OrderTag.ALI_MANAGED_SHIPPING} title="该订单为官方仓发订单，无需商家自行发货。">
                <OrderTagWrap className="order-icon icon-unimportant" orderTag={OrderTag.ALI_MANAGED_SHIPPING} />
            </Tooltip>,
        );
    }

    if (orderTagSet.has(OrderTag.ALI_DELIVERY_GUARANTEE)) {
        icons.push(
            <OrderTagWrap
                key={OrderTag.ALI_DELIVERY_GUARANTEE}
                className="order-icon icon-unimportant"
                orderTag={OrderTag.ALI_DELIVERY_GUARANTEE}
            >
                官方直送
            </OrderTagWrap>,
        );
    }

    if (orderTagSet.has(OrderTag.ALI_AE_DOOR_PICKUP)) {
        icons.push(
            <OrderTagWrap
                key={OrderTag.ALI_AE_DOOR_PICKUP}
                className="order-icon icon-important"
                orderTag={OrderTag.ALI_AE_DOOR_PICKUP}
            />,
        );
    }

    if (orderTagSet.has(OrderTag.ALI_AE_SELF_SEND)) {
        icons.push(
            <OrderTagWrap
                key={OrderTag.ALI_AE_SELF_SEND}
                className="order-icon icon-important"
                orderTag={OrderTag.ALI_AE_SELF_SEND}
            />,
        );
    }

    if (orderTagSet.has(OrderTag.ALI_FULFILLMENT_BY_WAREHOUSE)) {
        icons.push(
            <Tooltip
                key={OrderTag.ALI_FULFILLMENT_BY_WAREHOUSE}
                title="1688推出产地云仓代发服务能力，商家选择加入后，云仓代发订单由云仓代商家发货取号履约，无需商家使用打单软件取号。若商家使用打单工具再次取号，将导致商家资损及履约异常。"
            >
                <OrderTagWrap
                    className="order-icon icon-unimportant"
                    orderTag={OrderTag.ALI_FULFILLMENT_BY_WAREHOUSE}
                />
            </Tooltip>,
        );
    }

    return icons;
}
